function convertDateToUTC(date: any) { 
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()); 
}

export function formatDate(date: string | Date) {
  var d = convertDateToUTC(new Date(date)),
  month = "" + (d.getMonth() + 1),
  day = "" + (d.getDate()),
  year = d.getFullYear();
  
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [day, month, year].join("/");
}

export function formatDateDB(date: string | Date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export function formatReal(value: string | number){
  value = value+'';
  
  if (value.indexOf(".") === -1) {
    value = value+'.00'
  }

  if (value.split('.')[1].length === 1) {
    value = value+'0'
  }
  
  const int = parseInt( value.replace(/[\D]+/g,'') );
  var tmp = int+'';
  tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
  if( tmp.length > 6 )
    tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
  return tmp;
}

export function formatCnpj(value: string){
  return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
}